

































































































































































import { UserStore } from '@/store/modules/user';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import AMSBreadcrumb from '@/components/AMSBreadcrumb.vue';
import AMSformTable from '@/components/AMSformTableTitle.vue';
import request from '@/utils/request';
import Utils from '@/utils/utils';
import AMSProductImg from '@/components/AMSProductImg.vue';
import AMSProduct from '../../../components/AMSProductCategorySelector.vue';
import { allStaff } from '@/api/staff';
import { getModuleName } from '@/utils/utils';
import moment from 'moment';
interface Form {
  filter?: string;
  status?: string;
  orderStartTime?: String;
  orderEndTime?: String;
  saleId?: string;
  beautyAdvisorId?: string;
  productCategoryId?: string;
  orderState?: string;
  productFilter?: string;
  orderType?: string;
}
@Component({
  components: {
    'ams-breadcrumb': AMSBreadcrumb,
    'ams-formtable': AMSformTable,
    'ams-product': AMSProduct
  }
})
export default class allocation extends Vue {
  form: Form = {
    orderStartTime:'',
    orderEndTime:''
  };
  /**销售 美导 */
  activeItems: any[] = [{ value: '', text: '全部' }];
  FilterItem = [
    { name: '全部', id: '', count: 'totalCount' },
    { name: '订单', id: 'CustomerOrder', count: 'customerOrderCount' },
    { name: '物料申请单', id: 'MaterialOrder', count: 'materialOrderCount' }
  ];
  BreadItem = [
    {
      text: '订单管理',
      disabled: false,
      href: 'allocation'
    },
    {
      text: '配货列表',
      disabled: true
    }
  ];
  api = '/api/Shipment/AllocationList';
  statusList: Array<any> = [
    { value: '', text: '全部' },
    { value: 'OutOfStock', text: '缺货' },
    { value: 'StockNotEnough', text: '有货，库存不足' },
    { value: 'StockEnough', text: '有货，库存充足' }
  ];
  orderStatus = [
    { text: '全部', value: '', count: 'totalCount' },
    { text: '待发货', value: 'Order ', count: 'orderCount' },
    { text: '部分发货', value: 'PartialDelivery ', count: 'partialDeliveryCount' }
  ];
  headers: object[] = [
    {
      text: '商品',
      align: 'left',
      sortable: false,
      value: 'product',
      width: 300,
      render: (h: any, param: any) => {
        return h(AMSProductImg, {
          props: {
            product: param.row[param.keyName],
            pictureWidth: 40,
            pictureHeight: 40,
            isShowNumber: true,
            isShowPrice: UserStore.isExternalShipper?false:true //外部仓库发货员 角色账号下不显示价格
          }
        });
      }
    },
    { text: '订购数', align: 'right', sortable: false, value: 'orderQuantity' },
    {
      text: '已配货数',
      sortable: false,
      align: 'right',
      value: 'allocationQuantity'
    },
    { text: '待配货数', align: 'right', sortable: false, value: 'pendingAllocationQuantity' },
    {
      text: '实际库存',
      sortable: false,
      align: 'right',
      value: 'stockQuantity'
    },
    {
      text: '库存状态',
      sortable: false,
      align: 'right',
      value: 'stockStatus',
      render: (h: any, param: any) => {
        return h('span', this.switchStatus(param.row[param.keyName]));
      }
    }
  ];
  orderStartTime = false;
  orderEndTime = false;
  lastTime = '';
  startTime = '';
  date = new Date().toISOString().substr(0, 10);
  intData = {};
  /**选中的状态 */
  selectStatusName: string = '全部';
  clickFilter(id: string) {
    this.form.orderType = id;
    console.log('clickFilter', id, this.form.orderType);
    (this.$refs.formtable as HTMLFormElement).query(true);
  }
  OtherDataGet(value: object) {
    this.intData = value;
  }

  mounted() {
    this.getStaff();
  }

  onOrderStateClear() {
    setTimeout(() => {
      this.form.orderState = '';
    }, 1);
  }

  //点击了销售的叉叉按钮
  onSaleClear() {
    setTimeout(() => {
      this.form.saleId = '';
    }, 1);
  }

  //点击了美导的叉叉按钮
  onGuiderClear() {
    setTimeout(() => {
      this.form.beautyAdvisorId = '';
    }, 1);
  }

  /**获取销售 美导*/
  getStaff() {
    allStaff({ isActive: true, permissionCheck: true }).then((data: any) => {
      this.activeItems = [{ value: '', text: '全部' }].concat(
        data.items.map((i: any) => {
          i.value = i.id;
          i.text = i.name;
          return i;
        })
      );
    });
  }
  onEnter() {
    this.$refs.BeginTimeText && (this.$refs.BeginTimeText as any).blur();
    this.$refs.EndTimeText && (this.$refs.EndTimeText as any).blur();
  }
 @Watch('lastTime', { immediate: true, deep: true })
  onStartTimeStrChange(newValue: string, oldValue: string) {
    this.form.orderEndTime = newValue ? moment(newValue).toISOString() : '';
  }
  @Watch('startTime', { immediate: true, deep: true })
  onEndTimeStrChange(newValue: string, oldValue: string) {
    this.form.orderStartTime = newValue ? moment(newValue).toISOString() : '';
  }
  @Watch('orderStartTime', { immediate: true, deep: true })
  onBeginTimeChange(newValue: boolean, oldValue: boolean) {
    const text = this.$refs.BeginTimeText as any;
    if (text && newValue == false) {
      text.focus();
    }
  }

  @Watch('orderEndTime', { immediate: true, deep: true })
  onEndTimeChange(newValue: boolean, oldValue: boolean) {
    const text = this.$refs.EndTimeText as any;
    if (text && newValue == false) {
      text.focus();
    }
  }

  get minDate() {
    return this.startTime;
  }
  get maxDate() {
    return this.lastTime;
  }

  created() {
    this.initForm();
    if (JSON.parse(localStorage.getItem(`${getModuleName(this.$route.name as string)}_search`) as string)) {
      this.form = JSON.parse(localStorage.getItem(`${getModuleName(this.$route.name as string)}_search`) as string);
      this.startTime = this.form.orderStartTime?moment(this.form.orderStartTime as string).format('YYYY-MM-DD'):'';
      this.lastTime = this.form.orderEndTime?moment(this.form.orderEndTime as string).format('YYYY-MM-DD'):'';
    }
  }
  initForm() {
    this.form = { orderState: '', status: '', saleId: '', beautyAdvisorId: '', productCategoryId: '',orderType:'' };
    this.lastTime =''
    this.startTime =''
  }
  switchStatus(status: string) {
    switch (status) {
      case 'OutOfStock':
        return '缺货';
      case 'StockNotEnough':
        return '有货，库存不足';
      case 'StockEnough':
        return '有货，库存充足';
    }
  }

  /**筛选中的状态的清除按钮点击事件 */
  onStatusClear() {
    const _this = this;
    this.$nextTick(() => {
      _this.selectStatusName = ' ';
      _this.form.status = '';
      setTimeout(() => {
        _this.selectStatusName = '全部';
      }, 1);
    });
  }

  /**选中了某一个状态 */
  onStatusClick(item: { text:string , value:string }) {
    this.selectStatusName = item.text;
    this.form.status = item.value;
  }
}
